import { Form, Modal, Select } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { AiOutlineClose, AiOutlineFilePdf } from "react-icons/ai";
import { useQuery, useQueryClient } from "react-query";
import { cloudFrontUrl, serverUrl } from "../../../../../nestserver";
const { Option } = Select;

const HomeWorkBroadcast = () => {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  const [classId, setClassId] = useState();
  const [visible, setVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const messageContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
  };

  const handleClassChange = (val) => {
    setClassId(val);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setVisible(true);
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setVideoModalVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedImage("");
  };

  // Helper function to determine media folder and type
  const getMediaInfo = (item) => {
    let folder = "images"; // Default
    let mediaType = item?.type;

    if (item?.type) {
      if (item.type === "IMAGE") folder = "images";
      else if (item.type === "PDF") folder = "pdf";
      else if (item.type === "VIDEO") folder = "video";
      else if (item.type === "AUDIO" || item.type === "VOICE") folder = "audio";
    } else {
      // Fallback to extension-based detection if type is not explicitly set
      const name = item?.name?.toLowerCase() || "";
      if (name.endsWith(".pdf")) {
        folder = "pdf";
        mediaType = "PDF";
      } else if (name.endsWith(".mp4")) {
        folder = "video";
        mediaType = "VIDEO";
      } else if (name.endsWith(".mp3")) {
        folder = "audio";
        mediaType = "AUDIO";
      } else if (name.endsWith(".wav") || name.endsWith(".webm")) {
        folder = "audio";
        mediaType = "VOICE";
      } else if (
        name.endsWith(".jpeg") ||
        name.endsWith(".jpg") ||
        name.endsWith(".png")
      ) {
        folder = "images";
        mediaType = "IMAGE";
      }
    }
    return { folder, mediaType };
  };

  async function fetchStudent() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data.result;
  }
  const students = useQuery("students/by-parent", fetchStudent);

  const fetchClassConversation = async (studentId) => {
    const selectedStudent = students?.data?.find(
      (student) => student._id === studentId,
    );
    const studentClassId =
      selectedStudent?.class?._id || selectedStudent?.class_id;

    if (!studentClassId) {
      return { result: { messages: [] } };
    }

    const url = serverUrl + "/v2/conversations/class/" + studentClassId;

    const res = await axios({
      method: "get",
      url: url,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };

  const classConversationDetails = useQuery(
    ["conversations", classId],
    () => fetchClassConversation(classId),
    {
      enabled: !!classId,
      onSuccess: () => {
        if (classId) {
          const selectedStudent = students?.data?.find(
            (student) => student._id === classId,
          );
          const studentClassId =
            selectedStudent?.class?._id || selectedStudent?.class_id;

          if (studentClassId) {
            const url =
              serverUrl +
              "/v2/conversations/class/" +
              studentClassId +
              "/read-message";

            axios({
              method: "patch",
              url: url,
              headers: {
                Authorization: `Bearer ${window.localStorage.getItem(
                  "jwt-token",
                )}`,
              },
            })
              .then(() => {
                queryClient.invalidateQueries(["students", classId]);
              })
              .catch((error) => {
                console.error("Error marking messages as read:", error);
              });
          }
        }
      },
    },
  );

  useEffect(() => {
    scrollToBottom();
  }, [classConversationDetails]);

  useEffect(() => {
    if (students.isSuccess && students.data.length > 0) {
      const firstStudent = students.data[0];
      setClassId(firstStudent._id);
      form.setFieldsValue({ class: firstStudent._id });
    }
  }, [students.isSuccess, students.data, form]);

  return (
    <div>
      <div className="p-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full screen-height "
        >
          <div className="flex gap-4 min-height">
            <div style={{ width: "30%" }} className="message-left-part">
              <Form
                form={form}
                name="dynamic_rule"
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item name="class" label="Student Name" className="w-30">
                  {students?.isSuccess && students?.data?.length === 1 ? (
                    <div className="border p-2 rounded">
                      {`${students.data[0].first_name} ${students.data[0].last_name}`}
                    </div>
                  ) : (
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select student"
                      className="w-full bg-gray-300"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onChange={handleClassChange}
                    >
                      {students?.isSuccess &&
                        students?.data?.map((data) => {
                          return (
                            <Option key={data?._id} value={data?._id}>
                              {`${data?.first_name} ${data?.last_name}`}
                            </Option>
                          );
                        })}
                    </Select>
                  )}
                </Form.Item>
              </Form>
            </div>
            <div style={{ width: "70%" }} className="instructor-broadcast">
              {classId ? (
                <>
                  <div className="flex justify-between items-center pb-4">
                    <h1 className="pb-2 text-base font-semibold">
                      Class BroadCast
                    </h1>
                    <AiOutlineClose
                      size={20}
                      onClick={() => {
                        setClassId(null);
                        form.resetFields(["class"]);
                      }}
                      className="cursor-pointer"
                    />
                  </div>
                  <div
                    className="message-chat-content-class pt-8 "
                    style={{ width: "70%", marginLeft: "auto" }}
                    ref={messageContainerRef}
                  >
                    {classConversationDetails?.data?.result?.messages ? (
                      classConversationDetails?.data?.result?.messages?.map(
                        (message) => {
                          const isTeacher = message?.sender?.teacher;
                          return (
                            <div key={message?._id}>
                              <div
                                className="flex items-center gap-4 pb-4 justify-end"
                                style={{ marginRight: "12px" }}
                              >
                                <div className="flex flex-col gap-4">
                                  <span>
                                    {message?.sender?.teacher &&
                                      `${message?.sender?.teacher?.first_name} ${message?.sender?.teacher?.last_name} `}
                                  </span>
                                  <span>
                                    {moment(message?.createdAt).format(
                                      "DD-MM-YYYY hh:mm A",
                                    )}
                                  </span>
                                </div>

                                <div
                                  className={`${
                                    isTeacher
                                      ? "message-box"
                                      : "message-box-other"
                                  }`}
                                >
                                  {message?.media &&
                                  Array.isArray(message.media) ? (
                                    message.media.map((mediaItem, index) => {
                                      const { folder, mediaType } =
                                        getMediaInfo(mediaItem);
                                      const mediaUrl = `${cloudFrontUrl}/${folder}/${mediaItem?.id}`;

                                      return (
                                        <div
                                          key={mediaItem.id || index}
                                          className="media-container"
                                        >
                                          {mediaType === "VIDEO" ? (
                                            <div
                                              className="relative cursor-pointer group"
                                              onClick={() =>
                                                handleVideoClick(mediaUrl)
                                              }
                                            >
                                              <video
                                                className="media-video"
                                                style={{
                                                  maxWidth: "100%",
                                                  borderRadius: "8px",
                                                  pointerEvents: "none",
                                                }}
                                              >
                                                <source
                                                  src={mediaUrl}
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                              <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors rounded-lg">
                                                <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center shadow-lg">
                                                  <div className="w-0 h-0 border-l-[12px] border-l-black border-y-[8px] border-y-transparent ml-1"></div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : mediaType === "AUDIO" ||
                                            mediaType === "VOICE" ? (
                                            <div className="flex flex-col items-center">
                                              <audio
                                                controls
                                                className="media-audio w-full min-w-[250px]"
                                                style={{
                                                  width: "100%",
                                                  minWidth: "250px",
                                                  borderRadius: "8px",
                                                  backgroundColor: "#f0f2f5",
                                                  padding: "5px",
                                                }}
                                              >
                                                <source src={mediaUrl} />
                                                Your browser does not support
                                                the audio tag.
                                              </audio>
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  marginTop: "4px",
                                                }}
                                              >
                                                {mediaItem?.name}
                                              </div>
                                            </div>
                                          ) : mediaType === "IMAGE" ? (
                                            <img
                                              src={mediaUrl}
                                              alt={mediaItem?.name}
                                              onClick={() =>
                                                handleImageClick(mediaUrl)
                                              }
                                              className="media-image cursor-pointer"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "fallback-image-url";
                                              }}
                                            />
                                          ) : mediaType === "PDF" ? (
                                            <a
                                              href={mediaUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="pdf-link"
                                            >
                                              <AiOutlineFilePdf size={35} />
                                              {mediaItem?.name}
                                            </a>
                                          ) : (
                                            <img
                                              src={mediaUrl}
                                              alt={mediaItem?.name}
                                              onClick={() =>
                                                handleImageClick(mediaUrl)
                                              }
                                              style={{
                                                height: "150px",
                                                width: "150px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                              }}
                                              className="media-image cursor-pointer"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "fallback-image-url";
                                              }}
                                            />
                                          )}
                                        </div>
                                      );
                                    })
                                  ) : message?.media ? (
                                    <div className="media-container">
                                      {(() => {
                                        const { folder, mediaType } =
                                          getMediaInfo(message.media);
                                        const mediaUrl = `${cloudFrontUrl}/${folder}/${message.media?.id}`;

                                        if (mediaType === "VIDEO") {
                                          return (
                                            <div
                                              className="relative cursor-pointer group"
                                              onClick={() =>
                                                handleVideoClick(mediaUrl)
                                              }
                                            >
                                              <video
                                                className="media-video"
                                                style={{
                                                  maxWidth: "100%",
                                                  borderRadius: "8px",
                                                  pointerEvents: "none",
                                                }}
                                              >
                                                <source
                                                  src={mediaUrl}
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                              <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors rounded-lg">
                                                <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center shadow-lg">
                                                  <div className="w-0 h-0 border-l-[12px] border-l-black border-y-[8px] border-y-transparent ml-1"></div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        } else if (
                                          mediaType === "AUDIO" ||
                                          mediaType === "VOICE"
                                        ) {
                                          return (
                                            <div className="flex flex-col items-center">
                                              <audio
                                                controls
                                                className="media-audio w-full min-w-[250px]"
                                                style={{
                                                  width: "100%",
                                                  minWidth: "250px",
                                                  borderRadius: "8px",
                                                  backgroundColor: "#f0f2f5",
                                                  padding: "5px",
                                                }}
                                              >
                                                <source src={mediaUrl} />
                                                Your browser does not support
                                                the audio tag.
                                              </audio>
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  marginTop: "4px",
                                                }}
                                              >
                                                {message.media?.name}
                                              </div>
                                            </div>
                                          );
                                        } else if (mediaType === "IMAGE") {
                                          return (
                                            <img
                                              src={mediaUrl}
                                              alt={message?.media?.name}
                                              onClick={() =>
                                                handleImageClick(mediaUrl)
                                              }
                                              style={{
                                                height: "150px",
                                                width: "150px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                              }}
                                              className="media-image cursor-pointer"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "fallback-image-url";
                                              }}
                                            />
                                          );
                                        } else if (mediaType === "PDF") {
                                          return (
                                            <a
                                              href={mediaUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="pdf-link"
                                            >
                                              <AiOutlineFilePdf size={35} />
                                              {message?.media?.name}
                                            </a>
                                          );
                                        } else {
                                          return (
                                            <img
                                              src={mediaUrl}
                                              alt={message?.media?.name}
                                              onClick={() =>
                                                handleImageClick(mediaUrl)
                                              }
                                              style={{
                                                height: "150px",
                                                width: "150px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                              }}
                                              className="media-image cursor-pointer"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "fallback-image-url";
                                              }}
                                            />
                                          );
                                        }
                                      })()}
                                    </div>
                                  ) : null}
                                  {message?.message}
                                </div>
                              </div>
                            </div>
                          );
                        },
                      )
                    ) : (
                      <div className="flex items-center h-full">
                        No message found
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex justify-center items-center h-full w-full">
                  No message found
                </div>
              )}
            </div>
          </div>
          <div className="flex"></div>
        </div>
      </div>
      <Modal
        visible={visible}
        footer={null}
        onCancel={() => setVisible(false)}
        width={500}
        centered
      >
        <img
          alt="Preview"
          style={{ width: "100%" }}
          src={selectedImage}
          className="modal-image"
        />
      </Modal>

      <Modal
        visible={videoModalVisible}
        footer={null}
        onCancel={() => {
          setVideoModalVisible(false);
          setSelectedVideo(null);
        }}
        width={800}
        centered
        destroyOnClose
        bodyStyle={{ padding: 0, backgroundColor: "black" }}
      >
        {selectedVideo && (
          <video
            controls
            autoPlay
            style={{ width: "100%", maxHeight: "80vh", display: "block" }}
          >
            <source src={selectedVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </Modal>
    </div>
  );
};

export default HomeWorkBroadcast;
